<template>
	<b-modal class="modal-content" ref="mdlNuovaPrestazioneComponent" title="Nuova Prestazione" @hide="onHide"
		no-close-on-backdrop no-close-on-select @ok="onOkMdlNuovaPrestazioneComponent">
		<div class="modal-body">
			<b-row>
				<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
					<label for="">Codice Prestazione</label>
					<div class="sa-search-search-wrapper">
						<b-form-input type="text" name="costo" min="0" class="form-control"
							v-model="jsonData.codicePrestazione"></b-form-input>
						<!-- <button @click="onClickRicerca" class="sa-ft-floating-btn primary" title="Cerca">
							<i class="fas fa-search"></i>
						</button> -->
					</div>
				</b-col>
				<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
					<label for="">Descrizione Prestazione</label>
					<b-form-textarea v-model="jsonData.descrizionePrestazione" rows="5" no-resize></b-form-textarea>
				</b-col>
				<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
					<label for="">Costo</label>
					<b-form-input type="number" name="costo" min="0" class="form-control"
						v-model="jsonData.costo"></b-form-input>
				</b-col>
				<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
					<label for="">Quantita Erogabile</label>
					<b-form-input type="number" name="quantita" min="0" class="form-control"
						v-model="jsonData.quantitaErogabile"></b-form-input>
				</b-col>
				<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
					<label for="">Durata media (in minuti)</label>
					<b-form-input type="number" min="0" name="durata" class="form-control"
						v-model="jsonData.durata"></b-form-input>
				</b-col>

			</b-row>
		</div>
		<template #modal-footer>
			<div class="d-flex justify-content-end w-100">
				<b-button size="sm" variant="danger" class="ml-2" @click="close"> Annulla

				</b-button>
				<b-button size="sm" variant="success" class="ml-2" @click="onOkMdlNuovaPrestazioneComponent"> {{
					isModifica ? "Modifica Prestazione" : "Salva Prestazione" }}
				</b-button>



			</div>
		</template>
	</b-modal>
</template>

<script>
import toast from '../../../template/layout/utility/sa-toast';

// import DatePicker from "vue2-datepicker";
// import moment from "moment";
export default {
	components: {},
	props: {
		durataAppuntamento: {
			type: Number,
			default: () => {
				return 0;
			},
		}
	},
	data() {
		return {
			jsonData: { codicePrestazione: null, descrizionePrestazione: null, costo: 0, durata: 0, quantitaErogabile: 0 },
			intervallo: null,
			isModifica: false,
			rowSelected: {}
		};
	},
	methods: {
		show() {
			let me = this;
			me.$refs.mdlNuovaPrestazioneComponent.show();
		},
		close() {
			let me = this;
			me.$refs.mdlNuovaPrestazioneComponent.hide();
		},
		onOkMdlNuovaPrestazioneComponent() {
			let me = this;
			let validation = me.validazione();
			if (!validation.esito) {
				me.generaBtoast(validation);
				return;
			}
			if (this.jsonData.durata == 0) {
				this.jsonData.durata = this.durataAppuntamento
			}
			this.isModifica ? this.$emit("modificaPrestazione", me.jsonData, this.rowSelected) : this.$emit("addPrestazione", me.jsonData);
			this.close();
		},
		nuovaPrestazione() {
			this.jsonData = { codicePrestazione: null, descrizionePrestazione: null, costo: 0, durata: 0, quantitaErogabile: 0 };
			this.show();
		},
		onModificaPrestazione(row) {
			this.isModifica = true;
			this.rowSelected = row;
			this.jsonData = JSON.parse(JSON.stringify(row.item));
			this.show();
		},
		onHide() {
			this.isModifica = false;
			this.rowSelected = {};
		},
		generaBtoast(validation) {
			toast.validation(validation)
		},
		validazione() {
			let esito = true;
			let msg = "";
			if (this.jsonData.codicePrestazione == null || this.jsonData.codicePrestazione.trim() == "") {
				msg += "Codice Prestazione Obbligatorio ! #";
				esito = false;
			}
			if (this.jsonData.descrizionePrestazione == null || this.jsonData.descrizionePrestazione.trim() == "") {
				msg += "Descrizione Prestazione Obbligatorio ! #";
				esito = false;
			}
			if (this.jsonData.durata > this.durataAppuntamento) {
				msg += "Durata prestazione non può essere superiore alla durata appuntamento ! #";
				esito = false;
			}
			return { esito: esito, msg: msg };
		}
	},
};
</script>

<style></style>
